import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import type { ComponentType } from "@repo/editor/types";
import { observer } from "mobx-react-lite";
import React, { forwardRef } from "react";
import * as t from "@rekajs/types";

export const TimeLineItemDefinition: ComponentSettingsProps = {
  year: {
    type: "string",
    label: "سال",
  },
  description: {
    type: "string",
    label: "توضیحات",
  },
  up: {
    type: "boolean",
    label: "بالا",
  },
};

interface TimelineProps {
  year: string;
  description: string;
  up: number;
}

const TimelineItemComponent = forwardRef<HTMLDivElement, TimelineProps>(
  (props, ref) => {
    return (
      <div className="relative z-10" ref={ref}>
        <div
          className={`md:size-16 size-10 p-4 rounded-full relative flex justify-center items-center ${props.up ? "bg-[#FF7700]" : "bg-[#FFA04D]"}`}
        >
          <div
            className={`h-40 flex justify-center absolute ltr:md:-left-[63%] ltr:-left-[75%] rtl:md:-right-[63%] rtl:-right-[75%]  -z-10 ${props.up ? "bottom-full items-start" : "top-full items-end"}`}
          >
            <div className="md:text-xl text-sm font-medium md:w-14 w-8">
              {props.year}
            </div>
            <div className="h-40 w-[0.5px] bg-[#636363]/80 mx-4 relative flex justify-center">
              <div
                className={`size-[4.5px] bg-[#636363] rounded-full absolute ${props.up ? "bottom-full" : "top-full"}`}
              />
            </div>
            <div className="xl:text-base lg:text-sm md:text-xs text-[9px] lg:w-40 md:w-28 w-14">
              {props.description}
            </div>
          </div>
        </div>
      </div>
    );
  }
);

TimelineItemComponent.displayName = "TimelineItemComponent";

export const TimelineItem = observer(
  TimelineItemComponent
) as unknown as ComponentType<TimelineProps>;

export const timeLineItemSettings: ComponentSettings = {
  name: "ETimeLineItem",
  props: TimeLineItemDefinition,
  label: "تایم لاین آیتم",
  widgets: {
    label: "تایم لاین آیتم",
    template: () =>
      t.componentTemplate({
        component: t.identifier({ name: "ETimeLineItem", external: true }),
      }),
  },
};

TimelineItem.componentSettings = timeLineItemSettings;
